import { useExamSessionStore } from '../../stores/StoreContext';
import { Heading } from '@smarterservices/smarter-ui';

const Name = () => {
    const firstName = useExamSessionStore((state) => state.userData.firstName);
    const lastName = useExamSessionStore((state) => state.userData.lastName);

    return (
        <Heading level="h1" variant='titleModule' as="span">
            {firstName} {lastName}
        </Heading>
    );

};

export default Name;